// extracted by mini-css-extract-plugin
export default {"preview":"MessagePreview_preview__hIuEh"};